  // jQuery(document).ready(function () {


  // add parahraph text to year pages
  var selectOne = $('.main-vehicle-container p');
  var selectTwo = $('#searchresults');
  if (selectOne.length === 0 && selectTwo.length === 0) {
      selectOne = $('<p>Please select the Year of your vehicle below:</p>')
          .prependTo('.main-vehicle-container'); 
  }

  // sort alphanumeric
  var sorted = $('.vehicle-year-container ul li').sort(function(a, b) {
    var a = $(a).find('a:first').text(), b = $(b).find('a:first').text();
    return a.localeCompare(b, false, {numeric: true})
  })

  $('.vehicle-year-container ul').html(sorted)

  // end year pages

    if (jQuery(window).width() < 991 ) {
      jQuery(".search-container").appendTo(".mobile_filter");
        jQuery("#shopper_review_page").prependTo(".reviews_mobile");
    }
    
    if (jQuery(window).width() > 992) {
      
    jQuery(".template-index .nav__item--parent").addClass("custom_nav_position");

    //Sticky filter remove/attach on home page
    jQuery(window).scroll(function() {    
        var scroll = jQuery(window).scrollTop();
      

        if (scroll >= 800) {
          var stickyFilterBanner = jQuery('.template-index .search-container').detach();
          jQuery('.template-index .header__wrap').append(stickyFilterBanner);
          jQuery(".template-index .nav__item--parent").removeClass("custom_nav_position");
          
        } 
    if (scroll <= 800) {
          var stickyFilterHeader = jQuery('.template-index .header__wrap .search-container').detach();
          jQuery('.template-index .home_filter').append(stickyFilterHeader);
          jQuery(".template-index .nav__item--parent").addClass("custom_nav_position");
        }
    });

    }
    
    //Category
    jQuery('#category').change(function(){
      var category = jQuery(this).val();
      if(category == 'motorcycle'){
        var json_url = "//cdn.shopify.com/s/files/1/0899/0534/t/47/assets/selectbox-motorcycle.js";
      }else if(category == 'snowmobile'){
        var json_url = "//cdn.shopify.com/s/files/1/0899/0534/t/47/assets/selectbox-snowmobile.js";
      }else{
        var json_url = "https://cdn.shopify.com/s/files/1/0899/0534/files/hidnationv7.json";
      }

      jQuery.getJSON(json_url, function( data ) {

        var allyear = "<option value=''>--Year--</option>";
        jQuery.each( data, function( key, val ) {
          allyear += "<option value='" + key + "'>"+ key +"</option>";
          //console.log(allyear);
        });

        jQuery("#year option").remove();
        jQuery("#year").append(allyear);

        //SORT BY DESC
        var selectList = jQuery('#year option[value!=""]');
        selectList.sort(function(x,y){return y.value - x.value});
        jQuery('#year').append(selectList);

        jQuery('#make,#model').prop('disabled', true);

      });
    });

    //YEAR
    jQuery('#year').change(function(){
      // your code should be here
      var year = jQuery(this).val();
      var category = jQuery('#category').val();

      if(category == 'motorcycle'){
        var json_url = "//cdn.shopify.com/s/files/1/0899/0534/t/47/assets/selectbox-motorcycle.js";
      }else if(category == 'snowmobile'){
        var json_url = "//cdn.shopify.com/s/files/1/0899/0534/t/47/assets/selectbox-snowmobile.js";
      }else{
        var json_url = "https://cdn.shopify.com/s/files/1/0899/0534/files/hidnationv7.json";
      }

      if(year){
        jQuery('#make').prop('disabled', false);
        jQuery('#model').val('').prop('disabled', true);
        getmakefromyear(json_url, year);

      }else{
        jQuery('#make').prop('disabled', true);
        jQuery('#model').prop('disabled', true);
      }
    });

    //MAKE
    jQuery('#make').change(function(){
      // your code should be here
      
      var category = jQuery('.category').val();
      if(category == 'motorcycle'){
        var json_url = "//cdn.shopify.com/s/files/1/0899/0534/t/47/assets/selectbox-motorcycle.js";
      }else if(category == 'snowmobile'){
        var json_url = "//cdn.shopify.com/s/files/1/0899/0534/t/47/assets/selectbox-snowmobile.js";
      }else{
        var json_url = "https://cdn.shopify.com/s/files/1/0899/0534/files/hidnationv7.json";
      }
      
      var make = jQuery(this).val();
      var year = jQuery("#year").val();

      if(make){
        getmodelfrommake(json_url, year, make);
        jQuery('#model').prop('disabled', false);
      }else{
        jQuery('#model').prop('disabled', true);
      }

    });

    //MODEL --- now a go button
    jQuery(document).ready(function($) {
      // Check if #myvachile_name span is empty
      if ($('#myvachile_name').text().trim() === "") {
        $('#myvachile_close').css('visibility', 'hidden');
      } else {
        $('#myvachile_close').css('visibility', 'visible');
      }
      
      $('#go_btn').click(function() {
        var model = $('#model').val();
        var year = $('#year').val();
        var make = $('#make').val();
    
        var model = encodeURIComponent(model);
        var year = encodeURIComponent(year);
        var make = encodeURIComponent(make);
    
        if (model) {
          var category = $('#category').val();
          if (category == 'motorcycle') {
            window.location.href = '/pages/motorcycle?q=' + year + "+" + make + "+" + model;
          } else if (category == 'snowmobile') {
            window.location.href = '/pages/snowmobile?q=' + year + "+" + make + "+" + model;
          } else {
            window.location.href = '/pages/search-result?q=' + year + "+" + make + "+" + model;
          }
        }
      });
    });


  // });

  
  var json_url = "https://cdn.shopify.com/s/files/1/0899/0534/files/hidnationv7.json"; 
  
  jQuery.getJSON(json_url, function( data ) {

    var allyear = "";
    
    jQuery.each( data, function( key, val ) {
      //console.log( "<option value='" + key + "'>"+ key +"</option>");
      allyear += "<option value='" + key + "'>"+ key +"</option>";

    }); 

    jQuery("#year").append(allyear);

    //SORT BY DESC
    var selectList = jQuery('#year option[value!=""]');
    selectList.sort(function(x,y){return y.value - x.value});
    jQuery('#year').append(selectList);
    
  });

function getmakefromyear(json_url, year) {
    var allmake = "<option value=''>--Make--</option>";
    jQuery.getJSON(json_url, function(data) {
        if (data[year]) { // Check if data[year] is defined
            jQuery.each(data[year], function(key, val) {
                allmake += "<option value='" + key + "'>" + key + "</option>";
            });
        } else {
            console.log("Year '" + year + "' not found in data");
        }
        jQuery("#make option").remove();
        jQuery("#make").append(allmake);
    });
}

function getmodelfrommake(json_url, year, make) {
    var allmodel = "<option value=''>--Model--</option>";
    jQuery.getJSON(json_url, function(data) {
        if (data[year]) { // Check if data[year] is defined
            if (data[year][make]) { // Check if data[year][make] is defined
                jQuery.each(data[year][make], function(key, val) {
                    allmodel += "<option value='" + key + "'>" + val + "</option>";
                });
            } else {
                console.log("Make '" + make + "' not found for year '" + year + "'");
            }
        } else {
            console.log("Year '" + year + "' not found in data");
        }
        jQuery("#model option").remove();
        jQuery("#model").append(allmodel);
    });
}

// jQuery(document).ready(function () {
  if(jQuery.cookie("vachile_name")){
    jQuery('#myvachile_name').html(jQuery.cookie("vachile_name"));
    jQuery('.myvachile a').attr('href', jQuery.cookie("vachile_url"));

  }else{
   // jQuery('.myvachile').remove();
  }



  jQuery('#myvachile_close').click(function(e){
    jQuery.removeCookie('vachile_name', { path: '/' });
    //jQuery.removeCookie("vachile_name");
    jQuery.removeCookie('vachile_url', { path: '/' });  

    const yearSelect = document.getElementById('year');
    const makeSelect = document.getElementById('make');
    const modelSelect = document.getElementById('model');
    yearSelect.selectedIndex = 0;
    makeSelect.selectedIndex = 0;
    modelSelect.selectedIndex = 0;

    //jQuery.removeCookie("vachile_url");
    jQuery('.myvachile').css('visibility', 'hidden');
    jQuery(this).css('visibility', 'hidden');
  });
// });

